export default {
  system: {
    user: 'User',
    level: 'Level',
    earnPerTap: 'Earn per tap',
    coinsToLevelUp: 'Coins to level up',
    profitPerHour: 'Profit per hour',
    coming1: 'Something interesting',
    coming2: 'coming up here soon....',
    close: 'Close',
    friends: 'Friends',
    continue: 'Continue',
  },
  settings: {
    chooseNetwork: 'Choose network',
    chooseLanguage: 'Choose language',
  },
  popup_CheckTask: {
    join: 'Join',
    check: 'Check',
    taskIsNotCompleted: "Task isn't completed",
  },
  popup_levelUp: {
    levelUp: 'Level up!',
    multiTap: 'Multitap',
    energyLimit: 'Energy limit',
  },
  popup_BalanceUp: {
    balanceUp: 'Balance update!',
    balanceDiffSinceLast: 'Your reward',
  },
  popup_BalanceTip: {
    tip: 'Boost your profit',
    message: 'Tap the Mine menu to buy upgrades for your network',
    description: 'Earn even when offline up to 3 hours',
  },
  popup_Bored: {
    header: 'The frog is bored!',
    message: 'Play with the frog.',
    description: 'If the frog is not played with for 3 hours, profit stops',
  },
  popup_Hungry: {
    header: 'The frog is hungry!',
    message: 'Feed the frog.',
    description: 'The more friends you have, the more coins each feeding can bring',
  },
  menu: {
    network: 'Network',
    mine: 'Mine',
    earn: 'Earn',
    food: 'Food',
  },
  tap: {
    bored: 'Bored',
    fun: 'Fun',
  },
  mineMenu: {
    activities: 'Activities',
    investments: 'Investments',
    web3: 'WEB3',
    achievements: 'Achievements',
  },
  leaderboard: {
    from: 'from',
    beTheFirst: 'Be the first!',
  },
  mine: {
    joinOurTG1: 'Join our Telegram channel,',
    joinOurTG2: 'to unlock!',
    unlock: 'Unlock',
  },
  friends: {
    inviteFriends: 'Invite friends!',
    receiveBonuses: 'You and your friend will receive bonuses',
    inviteFriend: 'Invite a friend',
    withTelegramPremium: 'with Telegram Premium',
    forYouAndYourFriend: 'for you and your friend',
    moreBonuses: 'More bonuses',
    listOfYourFriends: 'List of your friends',
    linkCopied: 'The invitation link has been copied to your clipboard!',
    playWithMe:
      'Join me and play to earn tokens through an airdrop!\n' +
      '💰 Grab your gift! +3000 coins for newcomers\n' +
      '🚀 Have Telegram Premium? Get +5000 coins!\n',
  },
  earn: {
    moreCoins: 'Earn more coins!',
    dailyTasks: 'Daily tasks',
    dailyReward: 'Daily reward',
    tasksList: 'Tasks list',
    joinOurTG: 'Join our Telegram channel',
    followOurX: 'Follow our X account',
    yourAd: 'Your advertisement could be here',
    connect: 'Contact the admin of our Telegram channel',
  },
  food: {
    hungry: 'Hungry',
    full: 'Full',
    frogIsFull: 'Frog is full',
    feed: 'Feed',
    bonus: 'Бонус',
    satiety: 'Satiety',
    hours: 'hours',
  },
  toast: {
    buyCard: {
      title: 'Achievement Unlocked!',
      subtitle: 'Time to lead your frog empire to greatness 👑',
    },
    feedFrog: {
      title: 'The Frog is Happy!',
      subtitle: 'Great job! Feed your pet to keep the smiles coming 🍽️',
    },
  },
};
